import gql from 'graphql-tag';

export default gql`
  mutation deleteS3Object($key: String!, $bucket: String!) {
    deleteS3Object(key: $key, bucket: $bucket)
  }
`;
